import { z } from "zod";
import { PERMISSIONS } from "../permissions";

/**
 * Yönetim paneli: ekip ve roller (K-092, K-095). Hassas yetki ve super admin verme dört göz onayı ister;
 * yetki geri alma ve hesabı pasifleştirme hemen uygulanır (güvenlik için gecikmez).
 */
const ID = z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
const codes = new Set<string>(PERMISSIONS.map((p) => p.code));
const PermissionCode = z.string().refine((c) => codes.has(c), { message: "unknown_permission" });

export const RoleGrant = z.object({ roleId: ID, marketId: ID.nullable().default(null) });

export const InviteStaffBody = z.object({
  email: z.string().trim().toLowerCase().email().max(254),
  jobTitle: z.string().trim().max(80).nullable().default(null),
  roles: z.array(RoleGrant).max(10).default([]),
});
export type InviteStaffBody = z.input<typeof InviteStaffBody>;

export const UpdateStaffBody = z.object({ jobTitle: z.string().trim().max(80).nullable() });

export const GrantRoleBody = RoleGrant;
export type GrantRoleBody = z.input<typeof GrantRoleBody>;

export const CreateRoleBody = z.object({
  code: z.string().regex(/^[a-z][a-z0-9_]{1,46}$/),
  name: z.string().trim().min(1).max(80),
  description: z.string().trim().max(255).nullable().default(null),
  permissions: z.array(PermissionCode).max(200).default([]),
});
export type CreateRoleBody = z.input<typeof CreateRoleBody>;

export const UpdateRoleBody = z
  .object({
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(255).nullable(),
  })
  .partial()
  .refine((b) => Object.keys(b).length > 0, { message: "empty" });

/** Rolün yetkilerinin tam listesi: çıkarılanlar hemen, eklenen hassas yetkiler onaya gider */
export const SetRolePermissionsBody = z.object({
  permissions: z.array(PermissionCode).max(200),
});
export type SetRolePermissionsBody = z.input<typeof SetRolePermissionsBody>;

export const RejectApprovalBody = z.object({
  reason: z.string().trim().max(500).nullable().default(null),
});

/** approval_requests.payload (onaylayan tam olarak bunu görür ve bu aynen uygulanır) */
export const StaffApprovalPayload = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("member_role"),
    userId: ID,
    email: z.string().nullable(),
    roleId: ID,
    roleName: z.string(),
    marketId: ID.nullable(),
    sensitivePermissions: z.array(z.string()),
  }),
  z.object({
    kind: z.literal("role_permissions"),
    roleId: ID,
    roleName: z.string(),
    add: z.array(z.string()),
  }),
  z.object({ kind: z.literal("super_admin"), userId: ID, email: z.string().nullable() }),
]);
export type StaffApprovalPayload = z.infer<typeof StaffApprovalPayload>;
